module.exports = {
	"5fe6cc0473e0d313": "登录失败",
	"ff09e2c6d332d9a9": "维保经销商售后服务经理",
	"e700c28686cf9239": "服务经理",
	"ac4b9e617b460217": "源主",
	"cf9e55be6bc85b96": "简述",
	"2b68d9152e3d3db1": "国防部部长",
	"051d6d3c0467ce2c": "销售公司",
	"8d7d36bc6fb6d6ac": "行政部",
	"2c3949540a8af2b2": "东区网发",
	"5cabbc13e4bee21a": "管理员",
	"42c4c030fab33ead": "市场部",
	"54f11cc55ea6122f": "品牌经销商A",
	"d115f29ef6edb41f": "销售部",
	"3417a5fcc3a35dec": "销售分部",
	"7bd27a06c47deebb": "经销商A销售分部",
	"465d732d68ebdfbb": "操作成功",
	"d3ad9f48039d6f36": "请输入符合规则的密码",
	"9b9a980dcdf8e51a": "密码长度10~16位，至少包含：大写字母、小写字母、数字或特殊字符(只能包括`~!@#$%^&*()_-)中的三种",
	"db2a83c04d0d85ee": "一",
	"c9e78713e31e5c0c": "二",
	"a0da04db4f9323b6": "三",
	"11071e8d339b611c": "四",
	"77c043016d325c68": "五",
	"3d86ac98afd3c98b": "六",
	"ac2c5e612fb71dbb": "日",
	"2a314654cf9d4b65": "刚刚",
	"400201ee4590ba25": "分钟前",
	"38dff0847f8b6b54": "小时前",
	"acc203985e88c8ff": "1天前",
	"9954ce6437e66f41": "月",
	"08dae0e0a7266acb": "时",
	"cdf97643b4d2b4ec": "分",
	"9e8d6372f23ed0ae": "版权所有",
	"922c2d41bd36ae30": "请检查您输入的网址是否正确，请点击以下按钮返回主页或者发送错误报告",
	"8cd396b24d50bde9": "返回首页",
	"34655267df949d36": "您访问的页面不存在...",
	"0c09f9f949502219": "输入你的会员名 / 手机号 / 邮箱",
	"e93cb6cc8d5978ed": "请输入密码",
	"f787a49b96414843": "请选择登录类别",
	"29feb2a0dd8c64aa": "经销商",
	"136c1cfccaefce89": "主机厂",
	"a16c753c0ce27b93": "消费者",
	"a787eaff540ed815": "奇瑞国际智能营销平台",
	"8efc7ede2b82d0d2": "欢迎登录",
	"b6bd35b4275ff215": "普通登录",
	"c7609e554782bec4": "登 录",
	"5c839808c79ec750": "忘记密码？",
	"4c04782973d13249": "请输入正确的密码",
	"35a9eeeeed94b9c5": "身份验证",
	"1f899a083534373c": "重置新密码",
	"25e03120b83ee4ed": "完成",
	"3037d5200851358c": "请输入新密码",
	"12486c6be40db3e7": "请再次输入新密码",
	"204ffab8a6e01870": "确定",
	"cb5652273096ee32": "返回登录页",
	"47a48843580a4a66": "请输入格式正确的密码",
	"9be71a11b46a4836": "两次输入的密码不一致",
	"6f43ea859d9f785b": "密码长度10~16位，数字、字母、字符(只能包括`~!@#$%^&*()_-)至少包含三种",
	"5f572f4cad00da16": "重置密码成功",
	"29799f539ee6b906": "请输入手机号",
	"f1ee1d97e869e447": "请输入验证码",
	"03108ca21c7aae62": "{0}秒后可再次获取",
	"7dca92c6a707efb7": "获取验证码",
	"b0dd7bfe25cfcd7c": "请输入正确的手机号",
	"c54f71547450a65d": "验证码已成功发送至{0}",
	"ace46c7b30cb9a6e": "获取验证码",
	"582eb6b01e3ddd0e": "手机号登录",
	"b43c9693cd8c2a86": "账号登陆",
	"e4e4d24449be2f3b": "邮箱登录",
	"a4132369592eddf8": "请输入你的手机号",
	"7b04a69f42606895": "请输入你的帐号",
	"616d3762556837aa": "请输入你的邮箱",
	"f6f6a306a8b4e68c": "输入你的手机号",
	"e78e5ae48541083f": "输入你的帐号",
	"e1171e54815f0502": "输入你的邮箱",
	"2d394cf2150beea9": "帐号登录",
	"9cd180bf2c9735b7": "验证码发送失败，请检查手机号。",
	"d49a93bb265a311d": "验证码",
	"e3fed7761201cc22": "看不清楚？换一个",
	"ad4345dbaabe1479": "提交"
};


//////////////////
// WEBPACK FOOTER
// ./locale/zh.js
// module id = oh0U
// module chunks = 8